import { useEffect, useRef } from 'react';
import { Icon } from '@/features/common/Icon';
import type { FormAlertProps } from '@/features/common/types/FormAlertProps';

/**
 * Why a form was refused, in the modal it was sent from: MUD's inline error message, as an alert so
 * it is read out as it appears, and scrolled into view — a long form is taller than its modal, and
 * the reason would otherwise appear where the reader is not looking.
 */
export function FormAlert({ message }: FormAlertProps) {
  const ref = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ block: 'nearest' });
  }, [message]);

  return (
    <p ref={ref} role="alert" className="message message--inline message--error">
      <Icon name="circle-error" className="message__icon" />
      <span>{message}</span>
    </p>
  );
}
